export default __webpack_public_path__ + "static/media/collectiveAd.b061283e.jpg";